export default __webpack_public_path__ + "static/AIAGC_EXHB_2-886c99d4c279dad5bc15badff51d8b4b.jpg";